export const SET_USER_COURSE_ROLE = 'SET_USER_COURSE_ROLE'